/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Button, Label } from "reactstrap";
import CenterModal from "./CenterModal";
import ActionButton from "../elements/ActionButton";

const ModalBoolean = ({
  isOpen,
  toggle,
  size,
  title,
  leftText = "Cancel",
  leftColor = "secondary",
  leftSelected,
  rightText = "Confirm",
  rightColor = "success",
  rightSelected,
  cancelSelected,
  children
}) => {
  // handlers
  const clickHandler = (callback) => {
    toggle?.();
    callback?.();
  };

  const getTitle = () => title ? <Label className="mb-3 text-center" tag="h3">{title}</Label> : null;

  return (
    <CenterModal isOpen={isOpen} toggle={toggle} size={size}>
      {cancelSelected ? (
        <div className="d-flex justify-content-between">
          <div style={{ width: "30px"}} />
          {getTitle()}
          <ActionButton type="close" onClick={cancelSelected} />
        </div>
      ) : getTitle()}
      {children}
      <div className="mt-3 d-flex justify-content-between">
        <Button color={leftColor} onClick={() => clickHandler(leftSelected)}>
          {leftText}
        </Button>
        <Button color={rightColor} onClick={() => clickHandler(rightSelected)}>
          {rightText}
        </Button>
      </div>
    </CenterModal>
  );
}
export default ModalBoolean;
